module.exports = __webpack_public_path__ + "static/media/dinosaur(11).b6701275.PNG";